import { useParams } from "react-router-dom";
import React, {useEffect, useState} from 'react';
import Moment from 'moment';
import '../ManagementSheets.scss';
import LoaderMin from 'components/blocks/Loader/LoaderMin';
import useGetCompleteRecord from "@/services/recordSheets/useGetCompleteRecord";
import useDecode from "@/hooks/useDecode";

type guid = string;
interface Management {
  name: string,
  date: string,
  company: string
}
interface SummaryCATA extends Management {        
    id: guid | string,
    date_summary_cata?: Date | string,
    is_single_payment_request?: boolean,
    is_invitation_payment_quotas?: boolean, //
    is_regularize_quotas?: boolean, //
    amount?: number, //
    description_cause: string,
    estimate_date?: Date | string,
    claim_date?: Date | string,
    dismissal_date?: Date | string,
    desisted_date?: Date | string,
    favorable_date?: Date | string,         
    start_effect?: Date | string,
    end_effect?: Date | string,
    unforable_date?: Date | string,
    start_date_benefit?: Date | string,
    end_date_benefit?: Date | string,
    cause_autonomous_cessation_description: string,        
    autonomouns_collective_description: string,        
    cata_status_description: string,           
    cause_extinction_suspension_description: string,
    record_id: guid,
    management_type: string,
    status_cata: StatusCataEnum,
    beginning_suspension: Date,
    ending_suspension: Date
}

export enum StatusCataEnum {
  InicioSolicitud = 1,
  AcuerdoFavorable = 2,
  AcuerdoDesfavorable = 3,
  ReclamacionPrevia = 4,
  EstimacionReclamacionPrevia = 5,
  DesestimacionReclamacionPrevia = 6,
  DesistidoAutonomo = 7,
  ExpedienteSuspendido = 8,
  FavorableFinSuspension = 9
}

const ResumenCATA:React.FC = () => {
  const params = useParams<{ detailId: string }>();
  const sheetId = params.detailId?.split('__')[1];
  const tokenResponse = useDecode("token");
  const {getCompleteRecordCata, record, loadingCompleteRecord,errorCompleteRecord} = useGetCompleteRecord();

  useEffect(()=> {
    getData();
    Moment().locale("es");
  },[])
  
  const getData = () => {
    getCompleteRecordCata(tokenResponse.extension_id, sheetId);
  }

  if(loadingCompleteRecord) {
    return (
      <section className="container">
        <LoaderMin/>
      </section>
    )
  }

  if(errorCompleteRecord) {
    return (
      <section className="container">
        <p className="loader-text">Lo sentimos, se ha producido un error.</p>
      </section>
    )
  }

  return (
    <>
    {record===null?
    <section className="container">
      <p className="loader-text">No hay datos para mostrar.</p>
    </section>
    :
    <section className="container">
      <div className="col-xl-12 remarkable">
        <div className="row">
          <div className="col-xl-12">
            <h3 className="remarkable-title">{'Datos expediente'}</h3>
          </div>
          <div className="col-xl-6">
            <div className="item">
              <label className="item-label">{'Estado'}</label>
              <input type="text" id="EstadosCATADescripcion" className="item-value" value={record.cata_status_description} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Colectivo autónomo'}</label>
              <input type="text" id="ColectivoAutonomosDescripcion" className="item-value" value={record.autonomouns_collective_description} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item item-checkbox">
              <input type="checkbox" id="EsSolicitudPagoUnico" value={'EsSolicitudPagoUnico'} defaultChecked={record.is_single_payment_request?true:false} readOnly={true}/>
              <label className="item-label">{'Solicitud pago único'}</label>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Fecha inicio prestación'}</label>
              <input type="text" id="FechaInicioPrestacion" className="item-value" value={record.start_date_benefit!==null?Moment(record.start_date_benefit).format("DD/MM/YYYY"):""} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Fecha fin prestación'}</label>
              <input type="text" id="FechaFinPrestacion" className="item-value" value={record.end_date_benefit!==null?Moment(record.end_date_benefit).format("DD/MM/YYYY"):""} readOnly={true}/>
            </div>
          </div>
        </div>
      </div>
      {/* 1 Inicio Solicitud */}
      {record.status_cata === StatusCataEnum.InicioSolicitud &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Inicio de solicitud'}</h3>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha'}</label>
                <input type="text" id="Fecha" className="item-value" value={record.date_summary_cata!==null?Moment(record.date_summary_cata).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-9">
              <div className="item">
                <label className="item-label">{'Causa Cese'}</label>
                <input type="text" id="DescripcionCausa" className="item-value" value={record.description_cause} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/*  2 Acuerdo Favorable */}
      {record.status_cata === StatusCataEnum.AcuerdoFavorable || record.status_cata === StatusCataEnum.FavorableFinSuspension &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Acuerdo Favorable'}</h3>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Favorable'}</label>
                <input type="text" id="FechaFavorable" className="item-value" value={record.favorable_date!==null?Moment(record.favorable_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-9">
              <div className="item">
                <label className="item-label">{'Causa Cese'}</label>
                <input type="text" id="DescripcionCausa" className="item-value" value={record.description_cause} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/* 3 Acuerdo Desfavorable */}
      {record.status_cata === StatusCataEnum.AcuerdoDesfavorable&&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Acuerdo Desfavorable'}</h3>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Inicio Efecto'}</label>
                <input type="text" id="InicioEfecto" className="item-value" value={record.start_effect!==null?Moment(record.start_effect).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Fin Efecto'}</label>
                <input type="text" id="FinEfecto" className="item-value" value={record.end_effect!==null?Moment(record.end_effect).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Desfavorable'}</label>
                <input type="text" id="FechaDesfavorable" className="item-value" value={record.unforable_date!==null?Moment(record.unforable_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-9">
              <div className="item">
                <label className="item-label">{'Causa Desestimación'}</label>
                <input type="text" id="DescripcionCausa" className="item-value" value={record.description_cause} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/* 4 Reclamación previa */}
      {record.status_cata === StatusCataEnum.ReclamacionPrevia &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Reclamación Previa'}</h3>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Reclamación'}</label>
                <input type="text" id="FechaReclamacion" className="item-value" value={record.claim_date!==null?Moment(record.claim_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-9">
              <div className="item">
                <label className="item-label">{'Causa Desestimación'}</label>
                <input type="text" id="DescripcionCausa" className="item-value" value={record.description_cause} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/* 5 Estimación reclamación previa */}
      {record.status_cata === StatusCataEnum.EstimacionReclamacionPrevia &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Estimación Reclamación Previa'}</h3>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Reclamación'}</label>
                <input type="text" id="FechaReclamacion" className="item-value" value={record.claim_date!==null?Moment(record.claim_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Estimación'}</label>
                <input type="text" id="FechaEstimacion" className="item-value" value={record.estimate_date!==null?Moment(record.estimate_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="item">
                <label className="item-label">{'Causa Desestimación'}</label>
                <input type="text" id="DescripcionCausa" className="item-value" value={record.description_cause} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/*  6 Desestimación Reclamación previa*/}
      {record.status_cata === StatusCataEnum.DesestimacionReclamacionPrevia &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Desestimación Reclamación Previa'}</h3>
            </div>          
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Reclamación'}</label>
                <input type="text" id="FechaReclamacion" className="item-value" value={record.claim_date!==null?Moment(record.claim_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Desestimación'}</label>
                <input type="text" id="FechaDesestimacion" className="item-value" value={record.dismissal_date!==null?Moment(record.dismissal_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="item">
                <label className="item-label">{'Causa Desestimación'}</label>
                <input type="text" id="DescripcionCausa" className="item-value" value={record.description_cause} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/* Para el estado 7: “Desistido por Autónomo” no se han encontrado registro de ejemplo. Mostrar solo la sección de “Datos expediente” y si queda algún campo sin sección comunicarlo para valorar dónde se ubica. */}
      {/*  7 Desistido por el autónomo*/}
      {record.status_cata === StatusCataEnum.DesistidoAutonomo &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
              <div className="col-xl-12">
                <h3 className="remarkable-title">{'Desistido por el autónomo'}</h3>
              </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Desistido'}</label>
                <input type="text" id="FechaDesistido" className="item-value" value={record.desisted_date!==null?Moment(record.desisted_date).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="item">
                <label className="item-label">{'Causa cese autónomos'}</label>
                <input type="text" id="CausaCeseAutonomosDescripcion" className="item-value" value={record.cause_autonomous_cessation_description} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/*  8 Expediente suspendido*/}
      {record.status_cata === StatusCataEnum.ExpedienteSuspendido &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Expediente Suspendido'}</h3>
            </div>
            <div className="col-xl-6">
              <div className="item">
                <label className="item-label">{'Causa Suspension'}</label>
                <input type="text" id="CausaExtincionSuspensionDescripcion" className="item-value" value={record.cause_extinction_suspension_description} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Inicio Suspensión'}</label>
                <input type="text" id="FechaInicioSuspension" className="item-value" value={record.beginning_suspension!==null?Moment(record.beginning_suspension).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Fin Suspensión'}</label>
                <input type="text" id="FechaFinSuspension" className="item-value" value={record.ending_suspension!==null?Moment(record.ending_suspension).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {/*  9 Favorable por fin de suspensión*/}
      {record.status_cata === StatusCataEnum.FavorableFinSuspension &&      
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Favorable por fin de suspensión'}</h3>
            </div>
            <div className="col-xl-6">
              <div className="item">
                <label className="item-label">{'Causa Suspension'}</label>
                <input type="text" id="CausaExtincionSuspensionDescripcion" className="item-value" value={record.cause_extinction_suspension_description} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Inicio Suspensión'}</label>
                <input type="text" id="FechaInicioSuspension" className="item-value" value={record.beginning_suspension!==null?Moment(record.beginning_suspension).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Fecha Fin Suspensión'}</label>
                <input type="text" id="FechaFinSuspension" className="item-value" value={record.ending_suspension!==null?Moment(record.ending_suspension).format("DD/MM/YYYY"):""} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
      {record.is_invitation_payment_quotas&&
        <div className="col-xl-12 remarkable">
          <div className="row">
            <div className="col-xl-12">
              <h3 className="remarkable-title">{'Invitación al pago'}</h3>
            </div>
            <div className="col-xl-3">
              <div className="item item-checkbox">
                <input type="checkbox" id="EsInvitacionPagoCuotas" value={'EsInvitacionPagoCuotas'} defaultChecked={record.is_invitation_payment_quotas?true:false} readOnly={true}/>
                <label className="item-label">{'Invitacion pago cuotas'}</label>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item item-checkbox">
                <input type="checkbox" id="EsRegularizaCuotas" value={'EsRegularizaCuotas'} defaultChecked={record.is_regularize_quotas?true:false} readOnly={true}/>
                <label className="item-label">{'Regulariza cuotas'}</label>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="item">
                <label className="item-label">{'Importe'}</label>
                <input type="text" id="Importe" className="item-value" value={record.amount} readOnly={true}/>
              </div>
            </div>
          </div>
        </div>
      }
    </section>
    }
    </>
  )
}

export default ResumenCATA;